import { MPL03_PLAN_KEY, PRIVATE_COURSE_PRICE_AUD } from './classroomPricing';

export interface ClassroomSubscriptionPlan {
  id: string;
  planKey: string;
  title: string;
  priceLine: string;
  description: string;
}

/** MPL-03 — single course price box per Architectural Manual. */
export const CLASSROOM_SUBSCRIPTION_PLANS: ClassroomSubscriptionPlan[] = [
  {
    id: 'single-course',
    planKey: MPL03_PLAN_KEY,
    title: '1 Course',
    priceLine: `1 Course @ $${PRIVATE_COURSE_PRICE_AUD} per course`,
    description: 'Select to highlight and open the payment parameters block.',
  },
];

export const DEFAULT_CLASSROOM_SUBSCRIPTION_PLAN_ID = 'single-course';

const PLAN_KEY_BY_ID = Object.fromEntries(
  CLASSROOM_SUBSCRIPTION_PLANS.map((plan) => [plan.id, plan.planKey]),
) as Record<string, string>;

export function resolveClassroomSubscriptionPlanKey(planId: string): string | undefined {
  return PLAN_KEY_BY_ID[planId];
}
